import PropTypes from 'prop-types';
import React from 'react';
import { SHARE } from '../../../config/text/text';
import { getShowReviews } from '../../../helpers/deals';
import MainDealBoughtCount from '../MainDealBoughtCount';
import MainDealDiscount from '../MainDealDiscount';
import MainDealReviewOverview from '../MainDealReviewOverview';
import MainDealShare from '../MainDealShare';

const ActionsMetaBlock = ({ deal, toReviews, isTravel = false }) => {
  return (
    <>
      <div className="meta-block-about">
        <div className="meta-block-about__info">
          <div className="row no-margin">
            <div className="bought-container col-6 no-padding">
              <MainDealBoughtCount deal={deal} />
            </div>
            <div className="col-6 no-padding">
              <MainDealDiscount deal={deal} />
            </div>
          </div>
          <div className="row no-padding pt-2 meta-block-about__bottom">
            {getShowReviews(deal, isTravel) ? (
              <>
                <div className="col-6">
                  <MainDealReviewOverview
                    deal={deal}
                    isTravel={isTravel}
                    toReviews={toReviews}
                  />
                </div>
                <div className="col-6 deal-main-deal__share--side no-padding">
                  <h4>{SHARE}</h4>
                  <MainDealShare deal={deal} size="small" />
                </div>
              </>
            ) : (
              <div className="col-12 deal-main-deal__share--side">
                <h4>{SHARE}</h4>
                <MainDealShare deal={deal} size="small" />
              </div>
            )}
          </div>
        </div>
      </div>
      <style jsx>{`
        .meta-block-about {
          display: block;
          padding: 0px 10px;
        }

        .no-margin {
          margin: 0px;
        }

        .no-padding {
          padding: 0px;
        }
        .meta-block-about__bottom {
          padding: 10px 0px;
        }

        :global(.meta-block-about__bottom .review-overview) {
          justify-content: center;
        }

        .meta-block-about__info .bought-container {
          text-align: center;
        }
      `}</style>
    </>
  );
};

ActionsMetaBlock.propTypes = {
  deal: PropTypes.object.isRequired,
  isTravel: PropTypes.bool,
  toReviews: PropTypes.func.isRequired,
};

export default ActionsMetaBlock;
